import {api} from './api';
import {buildURLSearch} from '../utils/apiUtils';

export const fileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPhraseFile: builder.query<any, {fileName: string; phraseId: number; thumb?: boolean}>({
      query: ({fileName, phraseId, thumb}) => ({
        url: `/files/${phraseId}${buildURLSearch({fileCategory: 11, fileName, thumb})}`,
        responseHandler: (response: any) => response.blob().then((blob: Blob) => URL.createObjectURL(blob)),
      }),
    }),
  }),
});

export const {useGetPhraseFileQuery} = fileApi;
